export default "mutation exportBill($requestParams: LazyBillRequestParam) {\n  exportBill(requestParams: $requestParams) \n}";